export const colors = {
  Draft: '#5c75ad',
  'In Progress': '#0f9ecf',
  Filed: '#00e89b',
  Refile: '#d95094',
  'Compile Docs': '#ee9280',
  Active: '#ffb822',
  InActive: '#637381'
}